import React, { useEffect, useState } from "react";
import { staffApi } from "@/lib/staffApi";
import { CustomerSubmissionModal } from "./CustomerSubmissionModal";

export function photographyAnswers(submission) {
    return (submission.sections_snapshot || []).flatMap(section => (section.fields || [])
        .filter(field => !["informational_text", "section_heading", "signature"].includes(field.kind)
            && /photograph|photography|photo consent/i.test(`${section.title || ""} ${field.label || ""}`))
        .map(field => {
            const value = submission.answers?.[field.id];
            const display = item => {
                const option = (field.options || []).find(o => typeof o === "object" && o.value === item);
                return option?.label || (item === true ? "Yes" : item === false ? "No" : String(item));
            };
            return { id: field.id, question: field.label, answer: value == null || value === "" || (Array.isArray(value) && !value.length)
                ? "Not answered" : Array.isArray(value) ? value.map(display).join(", ") : display(value) };
        }));
}

export function PhotographyConsentPanel({ appointmentId }) {
    const [forms, setForms] = useState(null);
    const [error, setError] = useState("");
    const [selected, setSelected] = useState(null);
    const [revision, setRevision] = useState(0);
    useEffect(() => {
        let active = true;
        setForms(null); setError("");
        staffApi.listAppointmentSubmissions(appointmentId).then(async result => {
            const details = await Promise.all((result.submissions || []).map(form => staffApi.getSubmission(form.id)));
            const seen = new Set();
            if (active) setForms(details.map(r => ({ ...r.submission, photography: photographyAnswers(r.submission) }))
                .sort((a, b) => String(b.submitted_at).localeCompare(String(a.submitted_at)))
                .filter(form => { const key = form.template_id || form.id; if (seen.has(key)) return false; seen.add(key); return true; })
                .filter(form => form.photography.length));
        }).catch(() => { if (active) setError("Could not load photography answers. Please refresh."); });
        return () => { active = false; };
    }, [appointmentId, revision]);
    return <section className="min-w-0 w-full rounded-2xl glass p-5 space-y-4" data-testid="photography-consent">
        <div className="flex flex-wrap justify-between gap-3">
            <h2 className="font-serif text-2xl text-white">Photography consent</h2>
            <button className="text-sm text-gold" onClick={() => setRevision(n => n + 1)}>Refresh</button>
        </div>
        <p className="text-xs text-white/60">Latest submitted answers from each form for this appointment.</p>
        {error ? <p role="alert" className="text-amber-200">{error}</p> : forms === null ? <p className="text-white/60">Loading submitted answers…</p>
            : !forms.length ? <p className="text-white/60">No photography consent answers received for this appointment yet.</p>
            : forms.map(form => <div key={form.id} className="rounded-xl border hairline p-4 space-y-3 [overflow-wrap:anywhere]">
                <div className="text-sm text-white/60">{form.title_snapshot || "Completed form"} · {new Date(form.submitted_at).toLocaleString("en-GB")}</div>
                {form.photography.map(answer => <div key={answer.id}><p className="text-sm text-white/70">{answer.question}</p><p className="text-white font-semibold mt-1">{answer.answer}</p></div>)}
                <button onClick={() => setSelected(form.id)} className="text-gold text-sm">View completed form</button>
            </div>)}
        {selected && <CustomerSubmissionModal id={selected} onClose={() => setSelected(null)} />}
    </section>;
}
